import { AuthService } from '@lumora/common';
import { createContext } from 'react';

/**
 * Context for providing AuthService instance to components
 */
export const AuthServiceContext = createContext<AuthService | null>(null);
